import React from 'react';
import { IconSvgProps } from '@models/common';

const NavAllTools: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.143 4H4.857C4.62971 4 4.41173 4.09029 4.25101 4.25101C4.09029 4.41173 4 4.62971 4 4.857V9.143C4 9.616 4.384 10 4.857 10H9.143C9.37029 10 9.58827 9.90971 9.74899 9.74899C9.90971 9.58827 10 9.37029 10 9.143V4.857C10 4.62971 9.90971 4.41173 9.74899 4.25101C9.58827 4.09029 9.37029 4 9.143 4ZM19.143 4H14.857C14.6297 4 14.4117 4.09029 14.251 4.25101C14.0903 4.41173 14 4.62971 14 4.857V9.143C14 9.616 14.384 10 14.857 10H19.143C19.3703 10 19.5883 9.90971 19.749 9.74899C19.9097 9.58827 20 9.37029 20 9.143V4.857C20 4.62971 19.9097 4.41173 19.749 4.25101C19.5883 4.09029 19.3703 4 19.143 4ZM9.143 14H4.857C4.62971 14 4.41173 14.0903 4.25101 14.251C4.09029 14.4117 4 14.6297 4 14.857V19.143C4 19.616 4.384 20 4.857 20H9.143C9.37029 20 9.58827 19.9097 9.74899 19.749C9.90971 19.5883 10 19.3703 10 19.143V14.857C10 14.6297 9.90971 14.4117 9.74899 14.251C9.58827 14.0903 9.37029 14 9.143 14ZM19.143 14H14.857C14.6297 14 14.4117 14.0903 14.251 14.251C14.0903 14.4117 14 14.6297 14 14.857V19.143C14 19.616 14.384 20 14.857 20H19.143C19.3703 20 19.5883 19.9097 19.749 19.749C19.9097 19.5883 20 19.3703 20 19.143V14.857C20 14.6297 19.9097 14.4117 19.749 14.251C19.5883 14.0903 19.3703 14 19.143 14Z'
        stroke='currentColor'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default NavAllTools;
